import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getByNip(nip: string) {
        return useApiClient().get(`/external-data/get-by-nip/${nip}`);
    },
};
